import { ChakraProvider } from "@chakra-ui/react"
import { replace } from "@wordpress/shortcode"
import React from "react"
import { renderToString } from "react-dom/server"
import theme from "~/@chakra-ui/gatsby-plugin/theme"
import AppStoreButtons from "~/components/common/AppStoreButtons"
import { ShortCodeParser, ShortCodeStateEntities } from "../replaceShortCodes"

export const parser: ShortCodeParser = (
  html: string = "",
  state: ShortCodeStateEntities
) => {
  return replace("appButtons", html, args => {
    const justify = args.attrs.named.justify ?? "left"
    if (!state.appConfig) {
      return ""
    }

    const { iosStoreUrl, androidStoreUrl, language } = state.appConfig

    const rendered = renderToString(
      <ChakraProvider theme={theme}>
        <AppStoreButtons
          justify={justify}
          direction="column"
          appStoreUrl={iosStoreUrl}
          googlePlayUrl={androidStoreUrl}
          language={language}
        />
      </ChakraProvider>
    )

    return rendered
  })
}
